import { makeGenericApiAction } from './shared/helpers';

/**
 * Find which days are available
 * @returns
 */
export const fetchMonthlyAvailabilitiesAction = (month) => async (dispatch) => {
  makeGenericApiAction({
    action: 'FETCH_MONTHLY_AVAILABILITIES',
    model: 'fetchMonthlyAvailabilities',
    errorMessage: 'an error occurred while retrieving monthly availability.',
    dispatch,
    method: 'get',
    path: `bookings/getAvailabilityAPI?limitToMonthYear=${month}`,
  });
};
